import { Injectable } from '@angular/core';
import feather from 'feather-icons';
import uuid from 'short-unique-id';
import Swal, { SweetAlertResult } from 'sweetalert2'
import { GlobalService } from 'app/global/global.service';
import { Subscription } from 'rxjs';
import { Block } from 'app/interfaces/blocks';
import { TranslocoService } from '@jsverse/transloco';
import { ListingPopover, TablePopover } from './popover.dto';

@Injectable({
    providedIn: 'root'
})
export class PopOver {
    public uuid = new uuid({ length: 6, dictionary: 'number' });
    public timeOutSubscription: Subscription;
    constructor(private GlobalService: GlobalService,
        private _translocoService: TranslocoService,
    ) {}

    allowedSelf(){
        return this;
    }


    /**
     * Pdf break popover
     * @returns popover HTML
     */
    pageBreakPopOver() {
        return `<div class="pageBreak-popover-container">
            ${feather.icons.trash.toSvg({ class: 'cursor-pointer delete-page-break', width: 16, height: 16 })}
        </div>`
    }


    /**
     * Get class type
     * @param element 
     * @param target 
     * @returns Class type
     */
    classType(element, target) {
        let classType = 'default-block';
        if (element.hasClass('form-builder-block')) {
            classType = 'form-builder';
        } else if (element.hasClass('pdf-block')) {
            classType = 'pdf-block';
        } else if ((element.hasClass('content-editor-block') || element.find('.cke_editable_inline').length) && (!target.parents('.content-field-inner').length && !target.hasClass('content-field-inner'))) {
            classType = 'content-box';
        } else if (target.parents('.content-field-inner').length || target.hasClass('content-field-inner')) {
            classType = 'field-block';
        }
        return classType;
    }


    /**
     * Confirm alert
     * @param title 
     * @param message 
     * @param callback 
     */
    confirmAlert(title: string, message: string, callback: (result:SweetAlertResult)=>void) {
        Swal.fire({
            title: title,
            text: message,
            showCancelButton: true,
            confirmButtonColor: '#0161EF',
            cancelButtonColor: '#ccc',
            confirmButtonText: this._translocoService.translate("Sweetalert button text for confirmation deletion (Template/Document - section) - Yes delete")
        }).then((result) => {
            if (callback) {
                callback(result);
            }
        })
    }

    /**
     * listing popover 
     * @param params 
     * @returns popover html
     */
    listingPopover(params:ListingPopover) {
        return `<div class="block-sort"><div class="block-sort-inner-div" uuid="${params.uuid}"></div></div><div class="block-settings">
            <div class="block-action-btn open-editor-menu" uuid="${params.uuid}" classtype="${params.classType}" contenttype="${params.contentType}">
                
            </div>
        </div>`
    }


    /**
     * Append listing popover
     * @param params 
     * @returns icon or HTML
     */
    appendListingPopover(params: ListingPopover) {
        let icon = '';
        let pdfOrPageBreak = ``;
        if(params?.classType == 'page-break' && this.GlobalService.fields_data['blocks']){
            const pdfBreak:Block = this.GlobalService.fields_data['blocks'][params?.uuid];
           pdfOrPageBreak = `<div class="block-action-menu-list convert-${params?.classType}">
                <div class="block-action-menu-list-icon">
                    ${feather.icons['scissors'].toSvg({ class: `cursor-pointer delete-${params?.classType}`, width: 16, height: 16 })}
                </div>
                <div class="block-action-menu-list-label">
                    <p>${this._translocoService.translate("Box three dot menu option (Template/Document - section) - Convert to", {type: pdfBreak?.type == 'page-break' ? this._translocoService.translate("Box three dot menu option (Template/Document - section) - PDF break") : this._translocoService.translate("Box three dot menu option (Template/Document - section) - Page break")})}</p>
                </div>
            </div>`     
        }
        if (typeof params?.contentType != 'undefined' && params?.contentType && (params?.contentType == 'settings' || params?.classType == 'content-box' || params?.classType == 'page-break')) {
            icon = `
                <div class="block-action-menu-list ${params?.classType}-settings">
                    <div class="block-action-menu-list-icon">
                        ${feather.icons.sliders.toSvg({ class: `cursor-pointer ${params?.classType}-settings`, width: 16, height: 16 })}
                    </div>
                    <div class="block-action-menu-list-label">
                    <p>${this._translocoService.translate("Box three dot menu option (Template/Document - section) - Setting")}</p>
                    </div>
                </div>
                `;
        }
        return `<div class="block-action-menu hidden" uuid="${params?.uuid}">
                ${icon}
                <div class="block-action-menu-list ${(['content-box','table'].includes(params?.classType) ? '' : 'hidden')} duplicate-${params?.classType}">
                    <div class="block-action-menu-list-icon">
                        ${feather.icons['copy'].toSvg({ class: `cursor-pointer duplicate-${params?.classType}`, width: 16, height: 16 })}
                    </div>
                    <div class="block-action-menu-list-label">
                        <p>${this._translocoService.translate("Box three dot menu option (Template/Document - section) - Duplicate")}</p>
                    </div>
                </div>
                ${pdfOrPageBreak}
                <div class="block-action-menu-list delete-${params?.classType}">
                    <div class="block-action-menu-list-icon">
                        ${feather.icons['trash'].toSvg({ class: `cursor-pointer delete-${params?.classType}`, width: 16, height: 16 })}
                    </div>
                    <div class="block-action-menu-list-label">
                        <p>${this._translocoService.translate("Box three dot menu option (Template/Document - section) - Delete")}</p>
                    </div>
                </div>
            </div>`
    }


    /**
     * Image box listing popover
     * @param params 
     * @returns popover html 
     */
    imageBoxListPopover(params:ListingPopover) {
        return `<div class="block-sort"><div class="block-sort-inner-div" uuid="${params.uuid}"></div></div><div class="block-settings">
            <div class="block-action-btn open-editor-menu other-popover" uuid="${params.uuid}" classtype="${params.type}">
                ${feather.icons['more-vertical'].toSvg({ class: `curpagesor-pointer`, width: 14, height: 14 })}
            </div>
        </div>`
    }

    /**
     * Append image box list popover
     * @param params
     * @returns popover html
     */
    appendImageBoxListPopover(params: ListingPopover){
        let hasImage = this.GlobalService.fields_data['blocks'][params.uuid];

        // If block data doesn't exist, check if the image exists in DOM and create minimal block data
        if (!hasImage) {
            const imageElement = document.querySelector(`[editor-uuid="${params.uuid}"] .image-boxInner`);
            if (imageElement && Object.prototype.hasOwnProperty.call(this.GlobalService.fields_data, 'blocks')) {
                const backgroundImageStyle = (imageElement as HTMLElement).style.backgroundImage;
                const hasFile = backgroundImageStyle && backgroundImageStyle !== 'none' && backgroundImageStyle !== '';

                // Create minimal block data
                this.GlobalService.fields_data['blocks'][params.uuid] = {
                    uuid: params.uuid,
                    type: 'image',
                    file: hasFile ? { url: backgroundImageStyle } : null,
                    url: hasFile ? backgroundImageStyle : ''
                };
                hasImage = this.GlobalService.fields_data['blocks'][params.uuid];
            }
        }

        const replace = this._translocoService.translate("Box three dot menu option (Template/Document - section) - Replace");
        return `<div class="block-action-menu hidden" uuid="${params.uuid}">
                <div class="block-action-menu-list hidden duplicate-${params.classType}-box">
                    <div class="block-action-menu-list-icon">
                        ${feather.icons['copy'].toSvg({ class: `cursor-pointer duplicate-${params.classType}-box`, width: 16, height: 16 })}
                    </div>
                    <div class="block-action-menu-list-label">
                        <p>${this._translocoService.translate("Box three dot menu option (Template/Document - section) - Duplicate")}</p>
                    </div>
                </div>
                <div class="block-action-menu-list ${params.classType}-settings">
                    <div class="block-action-menu-list-icon">
                         ${feather.icons.sliders.toSvg({ class: `cursor-pointer ${params.classType}-settings`, width: 16, height: 16 })}
                    </div>
                    <div class="block-action-menu-list-label">
                        <p>${this._translocoService.translate("Box three dot menu option (Template/Document - section) - Setting")}</p>
                    </div>
                </div>
                ${hasImage?.file ? `<div class="block-action-menu-list upload-image-modal-setting" uuid="${params.uuid}" replace="1">
                    <div class="block-action-menu-list-icon">
                        ${feather.icons['refresh-ccw'].toSvg({ class: `cursor-pointer duplicate-${params.classType}-box`, width: 16, height: 16 })}
                    </div>
                    <div class="block-action-menu-list-label">
                        <p>${replace}</p>
                    </div>
                </div>` : ``}
                <div class="block-action-menu-list delete-${params.classType}-box">
                    <div class="block-action-menu-list-icon">
                        ${feather.icons['trash'].toSvg({ class: `cursor-pointer delete-${params.classType}-box`, width: 16, height: 16 })}
                    </div>
                    <div class="block-action-menu-list-label">
                        <p>${this._translocoService.translate("Box three dot menu option (Template/Document - section) - Delete")}</p>
                    </div>
                </div>
            </div>`
    }


    /**
     * Table popover
     * @param params 
     * @returns table popover html
     */
    tablePopover(params:TablePopover) {
        const disabled = params.isHeading == true ? 'pointer-none opacity-25' : '';
        return `
        <div class="tablePopover" style="position:absolute;top:${params.top}px;left:${params.left}px;">
            <div class="tablePopoverArrow"></div>
            <ul class="twoColUl">
                <li class="cursor-pointer add-content-table-column">${feather.icons['columns'].toSvg({ class: `cursor-pointer`, width: 16, height: 16 })} ${this._translocoService.translate("Box three dot menu option on table - (Template/Document - section) - Add column")}</li>
                <li class="cursor-pointer add-content-table-row">${feather.icons['minus-square'].toSvg({ class: `cursor-pointer`, width: 16, height: 16 })} ${this._translocoService.translate("Box three dot menu option on table - (Template/Document - section) - Add Row")}</li>
                <li class="cursor-pointer delete-content-table-column">${feather.icons['columns'].toSvg({ class: `cursor-pointer`, width: 16, height: 16 })} ${this._translocoService.translate("Box three dot menu option on table - (Template/Document - section) - Delete Column")}</li>
                <li class="cursor-pointer delete-content-table-row ${disabled}">${feather.icons['minus-square'].toSvg({ class: `cursor-pointer`, width: 16, height: 16 })} ${this._translocoService.translate("Box three dot menu option on table - (Template/Document - section) - Delete Row")}</li>
            </ul>
        </div>
        `
    }


    /** Destroy subscription */
    destroySubscription(){
        if(this.timeOutSubscription){
            this.timeOutSubscription.unsubscribe();   
        }
    }
}
